export { default as default } from './LocationSearchInput';
